import {useTheme} from "@emotion/react";
import TitleUnderlinedAnimated from "@/elements/TitleUnderlinedAnimated";
import type {SectionPushEntries} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import PushEntryCard from "./PushEntryCard";
import {CardsWrapper, InnerWrapper} from "./styles";

interface B17PushEntriesProps {
  sectionData: SectionPushEntries;
  isFirstSection?: boolean;
  isLastSection?: boolean;
}

const B17PushEntries = ({
  sectionData,
  isFirstSection,
  isLastSection,
}: B17PushEntriesProps) => {
  const {title, posts} = sectionData;
  const {breakpoints} = useTheme();
  const {md, isMobile} = breakpoints;
  return (
    <SectionWrapper
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
      styles={{paddingTop: 0}}
    >
      {!!posts?.length && (
        <InnerWrapper styles={{paddingBlock: isMobile ? 20 : 40}}>
          {title && (
            <TitleUnderlinedAnimated wrapperStyles={{marginBottom: md ? 14 : 34}}>
              {title}
            </TitleUnderlinedAnimated>
          )}
          <CardsWrapper>
            {posts.map((card) => (
              <PushEntryCard key={card.ID} cardData={card} lazy={!isFirstSection} />
            ))}
          </CardsWrapper>
        </InnerWrapper>
      )}
    </SectionWrapper>
  );
};

export default B17PushEntries;
